// One local profile for both ways of opening the app: through nginx (https://local.clinicalsuite.nxtrial.com, default
// port, APIs on api.<host>) or straight from ng serve / npx serve (http://<host>:<app port>, each backend on its own port)
const viaNginx = window.location.port === '';
const host = window.location.hostname;
const api = (path: string, port: number): string =>
    viaNginx ? `${window.location.protocol}//${host}/${path}` : `http://${host}:${port}/${path}`;

export const environment = {
    authApiUrl: api('auth', 8080),
    envName:"local",
    isLocalToServer: false,
    isNginx: viaNginx
  };
